module.exports = __webpack_public_path__ + "static/media/classroompic.df89fc56.png";